import styled from "styled-components";

const UrlBadge = styled.div`
    position: relative;
    width: 2rem;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    user-select: none;
    cursor: pointer;
`

export default UrlBadge;